





















































import {Mixins, Component, Watch} from 'vue-property-decorator'
import {MetaInfo} from 'vue-meta'
import Navbar from '@/components/navbar/Navbar.vue'
import AppFooter from '@/components/footer/AppFooter.vue'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {$} from '@/facade'
import MyWalletSection from '@/components/myWallet/MyWalletSection.vue'
import MyWalletTokensNftsSection from '@/components/myWallet/MyWalletTokensNftsSection.vue'
import MyWalletGetGasSection from '@/components/myWallet/MyWalletGetGasSection.vue'
import {MyWalletCacheAssist} from '@/helpers/MyWalletCacheAssist'
import MyWalletMyNfts from '@/components/myWallet/MyWalletMyNfts.vue'
import MyWalletConnectAddress from '@/components/myWallet/MyWalletConnectAddress.vue'
import MyWalletWatchOnlyDisclaimer from '@/components/myWallet/MyWalletWatchOnlyDisclaimer.vue'
import MyWalletOrbitOverview from '@/components/myWallet/MyWalletOrbitOverview.vue'

@Component({
  computed: {
    $() {
      return $
    },
  },
  components: {
    MyWalletOrbitOverview,
    MyWalletWatchOnlyDisclaimer,
    MyWalletConnectAddress,
    MyWalletMyNfts,
    MyWalletGetGasSection,
    MyWalletTokensNftsSection,
    MyWalletSection,
    AppFooter,
    Navbar,
  },
})
export default class MyWalletView extends Mixins(MixinScreenSize) {
  cacheAssist: MyWalletCacheAssist = new MyWalletCacheAssist(this.isMobile)

  displayDisclaimer = false
  walletPopulated = false
  currentPopulatedAddress: string | null = null
  isFirstLoad = true

  get isOrbitEnabled(): boolean {
    return this.$auth?.global?.isOrbitFeatureActive !== false
  }

  metaInfo(): MetaInfo {
    const title = this.$translate('metadata.title.myWallet') as string
    const description = this.$translate(
      'view.MyWalletView.metaDescription'
    ) as string

    return {
      title,
      meta: [
        {vmid: 'description', name: 'description', content: description},
        {vmid: 'og:title', property: 'og:title', content: title},
        {
          vmid: 'og:description',
          property: 'og:description',
          content: description,
        },
        {vmid: 'twitter:title', name: 'twitter:title', content: title},
        {
          vmid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
      ],
    }
  }

  async mounted() {
    this.cacheAssist = new MyWalletCacheAssist(this.isMobile)
    await this.handleFirstWalletLoad()
  }

  beforeDestroy() {
    $.watchWallet.setAddress('')
  }

  async populate(address: string) {
    this.displayDisclaimer = false
    this.walletPopulated = true
    this.currentPopulatedAddress = address
    await this.cacheAssist.populateWallet(address)
  }

  async handleFirstWalletLoad() {
    const n3 = $.walletAdapter.n3Address
    const neox = $.walletAdapter.xAddress

    if (n3) {
      await this.populate(n3)
    } else if (neox) {
      await this.populate(neox)
    } else {
      this.displayDisclaimer = true
    }

    this.isFirstLoad = false
  }

  resetToConnectState() {
    this.displayDisclaimer = true
    this.walletPopulated = false
    this.currentPopulatedAddress = null
  }

  @Watch('$store.state.walletAdapter.n3.address')
  async onN3AddressChange(address: string | null) {
    const neox = $.walletAdapter.xAddress

    if (address) {
      if (this.isFirstLoad || this.currentPopulatedAddress !== address) {
        await this.populate(address)
        this.isFirstLoad = false
      }
    } else {
      if (neox) {
        await this.populate(neox)
      } else {
        this.resetToConnectState()
      }
    }
  }

  @Watch('$store.state.walletAdapter.neoX.address')
  async onXAddressChange(address: string | null) {
    const n3 = $.walletAdapter.n3Address

    if (address) {
      if (
        (this.isFirstLoad && !n3) ||
        (!this.isFirstLoad && this.currentPopulatedAddress !== address)
      ) {
        await this.populate(address)
        this.isFirstLoad = false
      }
    } else {
      if (n3) {
        await this.populate(n3)
      } else {
        this.resetToConnectState()
      }
    }
  }
}
